module.exports = __webpack_public_path__ + "static/media/Cedar-Ridge-Master-Deed-ByLaws-Combined.22b28124.pdf";